import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=788a5587&"
import script from "./LogoutView.vue?vue&type=script&lang=js&"
export * from "./LogoutView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports